import { route } from "static-route-paths";

import { collectMixpanelRouteDefinitions, mixpanelRoute } from "../user-analytics/mixpanel-route";

export const routes = route({
  root: route(),
  enterpriseReport: route("enterprise-report/:reportSnapshotId"),
  reporting: mixpanelRoute("reporting", "reporting", {
    systems: route("systems", {
      show: route(":systemId", {
        reports: route("reports", {
          show: route(":reportId", {
            edit: route("edit"),
          }),
        }),
      }),
    }),
  }),
  sharedReport: mixpanelRoute("shared-report", route("shared-report/:shareLinkId")),
  dashboards: route("dashboards", {
    auditLog: route("audit-log"),
    logbookEntry: route("logbook-entry"),
    plugins: route("plugins", {
      amWaterExtensions: route("amwater-extensions", {
        chemicalReceiving: route("chemical-receiving"),
      }),
    }),
  }),
  // DEPRECATED: /accounts/ URLs are now /systems/
  accounts: route("accounts"),
  systems: route("systems", {
    show: route(":systemId", {
      labImport: route("labImport", {
        imports: route("imports", {
          show: route(":batchId"),
        }),
      }),
      chemicalReceiving: mixpanelRoute("chemicalReceiving"),
      sampleManagement: mixpanelRoute("sampleManagement"),
      wasteHauling: mixpanelRoute("wasteHauling"),
      sites: route("sites", {
        show: route(":siteId"),
        new: route("new"),
      }),
      dashboard: route("dashboard"),
      settings: route("settings"),
    }),
  }),
  users: route("users", {
    show: route(":userId"),
  }),
  organizations: route("organizations", {
    show: route(":organizationId", {
      settings: route("settings"),
      systemGroups: route("systemGroups", {
        show: route(":systemGroupId", {
          settings: route("settings"),
        }),
      }),
      systems: route("systems", {
        show: route(":systemId", {
          settings: route("settings"),
        }),
      }),
    }),
  }),
  signup: route("signup"),
  sso: route("sso/:idp", {
    login: route("login", {
      initiate: route("initiate"),
      callback: route("callback"),
    }),
  }),
  noAccess: route("noAccess"),
  admin: route("admin", {
    addNewSystem: route("addNewSystem"),
    bulkMetricEditor: route("bulkMetricEditor"),
    calcTreeGrapher: route("calcTreeGrapher"),
    queueManagement: route("queue-management"),
    queueMonitor: route("queueMonitor"),
    featureFlags: route("featureFlags"),
    edgeDevices: route("edgeDevices", {
      show: route(":edgeDeviceId"),
    }),
    waterlyConnect: route("waterlyConnect"),
    weatherDataStations: route("weatherDataStations"),
    timeSeries: route("timeSeries"),
    metricKeynames: route("metricKeynames"),
    unitManager: route("unitManager"),
    tagManager: route("tagManager"),
    notificationsManager: route("notificationsManager"),
    userManager: route("userManager"),
    calcDebugger: route("calcDebugger", {
      logs: route("logs"),
      calcClusterDebugManager: route("calcClusterDebugManager"),
    }),
    qrBuilder: route("qrBuilder"),
    cloningWizard: route("cloningWizard"),
    organizationInfo: route("organizationInfo"),
    emailManager: route("emailManager"),
    apiTokens: route("apiTokens"),
    organizationIntegrations: route("organizationIntegrations"),
    runtimeConfiguration: route("runtimeConfiguration"),
  }),
  overview: route("overview"),
  schedule: route("schedule", {
    activity: route("activity", {
      new: route("new"),
      items: route("items"),
      show: route(":activityScheduleId", {
        duplicate: route("duplicate"),
        items: route("items", {
          show: route(":itemId", {
            complete: route("complete"),
          }),
        }),
      }),
    }),
    sample: route("sample", {
      new: route("new"),
      items: route("items"),
      show: route(":sampleId", {
        duplicate: route("duplicate"),
        items: route("items", {
          show: route(":itemId"),
        }),
      }),
    }),
    items: route("items", {
      show: route(":scheduledItemId", {
        complete: route("complete"),
      }),
    }),
  }),
  sample: route("sample", {
    collections: route("collections", {
      new: route("new"),
      show: route(":collectionId", {
        duplicate: route("duplicate"),
      }),
    }),
    site: route("site", {
      show: route(":sampleSiteId"),
      new: route("new"),
    }),
    analyte: route("analyte", {
      groups: route("groups", {
        show: route(":groupId"),
        new: route("new"),
      }),
      show: route(":analyteId"),
    }),
  }),
});

export const mixpanelRouteDefinitions = collectMixpanelRouteDefinitions(routes).sort(
  (left, right) => right.path.length - left.path.length,
);
